import { SharedDocumalisModule } from '@documalis/shared-documalis.module';
import { NgModule } from '@angular/core';
import { GroupRoutes } from './group.routes';
import { ListGroupsComponent } from './list-groups/list-groups.component';
import { FormGroupComponent } from './_components/form-user/form-group.component';
import { AddGroupComponent } from './add-group/add-group.component';
import { EditGroupComponent } from './edit-group/edit-group.component';
import { TranslateModule } from '@ngx-translate/core';
import { InputSwitchModule } from 'primeng/inputswitch';
import { PasswordModule } from 'primeng/password';
import { FieldsetModule } from 'primeng/fieldset';
import { RadioButtonModule } from 'primeng/radiobutton';

@NgModule({
    imports: [GroupRoutes, SharedDocumalisModule, TranslateModule, InputSwitchModule, PasswordModule, FieldsetModule, RadioButtonModule],
    declarations: [ListGroupsComponent, AddGroupComponent, EditGroupComponent, FormGroupComponent],
})
export class GroupModule {}
